<template>
  <div class="k-status">
    <span class="round-dot" :style="{background: color || statusColor}"></span>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  },
  computed: {
    statusColor() {
      switch (this.type) {
        case 'new':
          return '#D5D6DB'
        case 'pending':
          return '#64B3F4'
        case 'reject':
          return '#EF7A70'
        case 'approved':
          return '#89E27E'
        case 'warning':
          return '#FFB400'
        default: 
          return '#D5D6DB'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.k-status {
  font-size: 14px;
  display: flex;
  align-items: center;
  .round-dot {
    width: 12px;
    min-width: 12px;
    height: 12px;
    border-radius: var(--kk-radius-lg);
    margin-right: 10px;
    display: inline-block;
  }
}
</style>
